import HeaderSocials from "./HeaderSocials";
export default HeaderSocials;